<template>
  <form id="add-magazine-modal"
        method="POST"
        class="modal fade"
        tabindex="-1"
        data-backdrop="static"
        data-keyboard="false"
        role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content">
              <div class="modal-header">
                  <h5 class="modal-title">Solicitar registro de revista</h5>
              </div>
              <div class="modal-body">
                <div class="form-group mb-4">
                  <div class="form-group">
                    <label class="d-block font-weight-normal"
                          for="abbreviated_title">Título abreviado:
                      <abbr style="text-decoration: none;"
                            title="Campo obligatorio">*</abbr>
                    </label>
                    <input type="text"
                           name="abbreviated_title"
                           id="abbreviated_title"
                           placeholder="Escriba el título abreviado"
                           class="form-control"
                           v-model="abbreviated_title"/>
                  </div>
                </div>
                <div class="form-group mb-4">
                  <div class="form-group">
                    <label class="d-block font-weight-normal"
                          for="title">Título:
                      <abbr style="text-decoration: none;"
                            title="Campo obligatorio">*</abbr>
                    </label>
                    <input type="text"
                           name="title"
                           id="title"
                           placeholder="Escriba el título"
                           class="form-control"
                           v-model="title"/>
                  </div>
                </div>
                <div class="form-group mb-4">
                  <div class="form-group">
                    <label class="d-block font-weight-normal"
                          for="issn">ISSN:
                      <abbr style="text-decoration: none;"
                            title="Campo obligatorio">*</abbr>
                    </label>
                    <input type="text"
                          name="issn"
                          id="issn"
                          placeholder="Escriba el ISSN de la revista"
                          class="form-control"
                          v-model="issn"/>
                  </div>
                </div>
                <div class="form-group mb-4">
                  <div class="form-group">
                    <label class="d-block font-weight-normal"
                          for="impact">Factor de impacto:
                      <abbr style="text-decoration: none;"
                            title="Campo obligatorio">*</abbr>
                    </label>
                    <input type="number"
                          name="impact"
                          id="impact"
                          placeholder="Escriba el factor de impacto"
                          class="form-control"
                          v-model="impact"/>
                  </div>
                </div>
                <div class="form-group">
                  <label class="d-block font-weight-normal"
                        for="type">Tipo:
                    <abbr style="text-decoration: none;"
                          title="Campo obligatorio">*</abbr>
                  </label>
                  <select id="type"
                          class="custom-select"
                          name="type"
                          v-model="type">
                    <option v-for="option in typeList"
                            :key="option.value"
                            :value="option.value">
                      {{ option.text }}
                    </option>
                  </select>
                </div>
                <div class="form-group">
                  <label class="d-block font-weight-normal"
                        for="group">Grupo:
                    <abbr style="text-decoration: none;"
                          title="Campo obligatorio">*</abbr>
                  </label>
                  <select id="group"
                          class="custom-select"
                          name="group"
                          v-model="group">
                    <option v-for="option in groupList"
                            :key="option.value"
                            :value="option.value">
                      {{ option.text }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="modal-footer">
                  <button type="submit"
                          class="btn btn-primary"
                          :disabled="saving">
                    <spinner small class="text-white" v-if="saving"></spinner>
                    Aceptar
                  </button>
                  <button type="button"
                          class="btn btn-secondary"
                          data-dismiss="modal"
                          :disabled="saving">Cerrar
                  </button>
              </div>
          </div>
      </div>
  </form>
</template>

<script>
  import { AlertManager } from '../utils/AlertManager'
  import { mapActions } from 'vuex'
  import Spinner from '../ui/Spinner'
  import 'jquery-validation'
  import 'select2/dist/js/select2.min.js'
  
  export default {
    name: 'AddMagazineModal',
    components: {
      Spinner,
    },
    data() {
      return {
        saving: false,
        abbreviated_title: '',
        title: '',
        issn: '',
        impact: '',
        type: '',
        group: '',
        typeList: [
          {
            text: 'Seleccione un tipo',
            value: '',
          },
          {
            text: 'CONACYT',
            value: 'CONACYT',
          },
          {
            text: 'JCR CIENTIFICO',
            value: 'JCR CIENTIFICO',
          },
          {
            text: 'JCR SOCIAL',
            value: 'JCR SOCIAL',
          },
          {
            text: 'Otra',
            value: 'Otra',
          },
        ],
        groupList: [
          {
            text: 'Seleccione un grupo',
            value: '',
          },
          {
            text: 'Grupo I',
            value: 'I',
          },
          {
            text: 'Grupo II',
            value: 'II',
          },
          {
            text: 'Grupo III',
            value: 'III',
          },
          {
            text: 'Grupo IV',
            value: 'IV',
          },
          {
            text: 'Grupo V',
            value: 'V',
          },
          {
            text: 'Grupo VI',
            value: 'VI',
          },
          {
            text: 'Grupo VII',
            value: 'VII',
          },
        ],
      }
    },
    methods: {
      ...mapActions({
        requestMagazine: 'magazines/requestMagazine',
      }),

      async addMagazine() {
        this.saving = true
        
        const response = await this.requestMagazine({
          abbreviated_title: this.abbreviated_title,
          title: this.title,
          issn: this.issn,
          impact: this.impact,
          type: this.type,
          group: this.group,
        })
        
        this.saving = false
        
        const { error, status, message } = response
        
        if(status === 'error') {
          AlertManager.error(error)
          
          return
        }
        
        this.clearForm()
        AlertManager.success(message)
        
        $('#add-magazine-modal').modal('hide')
      },

      clearForm() {
        this.abbreviated_title = ''
        this.title = ''
        this.issn = ''
        this.impact = ''
        this.type = ''
        this.group = ''
      }
    },
    mounted() {
      const vm = this

      /**
       * Init JQuery validation
       */
      $(() => {
        const $form = $('#add-magazine-modal')

        /**
         * Validate modal form
         */
        $form.validate({
          ignore: [],
          highlight: function(element, errorClass, validClass) {
            $(element).addClass('is-invalid')
          },
          unhighlight: function(element, errorClass, validClass) {
            $(element).removeClass('is-invalid')
          },
          errorPlacement: function(label, element) {
            label.insertAfter(element)
            
            label.addClass('invalid-feedback')
          },
          rules: {
            abbreviated_title: {
              required: true,
            },
            title: {
              required: true,
            },
            issn: {
              required: true,
            },
            impact: {
              required: true,
            },
            type: {
              required: true,
            },
            group: {
              required: true,
            },
          },
          messages: {
            abbreviated_title: {
              required: 'Este campo es requerido.',
            },
            title: {
              required: 'Este campo es requerido.',
            },
            issn: {
              required: 'Este campo es requerido.',
            },
            impact: {
              required: 'Este campo es requerido.',
            },
            type: {
              required: 'Este campo es requerido.',
            },
            group: {
              required: 'Este campo es requerido.',
            },
          },
          submitHandler(form) {
            vm.addMagazine()
          },
        })
      })
    },
  }
</script>
